export enum ClientType {
  // DEFAULT_BASE = 0,
  Specialist = 1,
  Employer = 2,
  // MODERATOR = 3,
  // ADMINISTRATOR = 4,
}
